import JourneyList from './styled';

export default JourneyList;
